import axios, { AxiosError } from 'axios';
import { ApiFinanceira } from '../axiosfinanceiro';

interface IFoto {
  imgPath: string
}

export interface ICustoPatrimonios {
  descricao: string;
  numero: string;
  ano: string;
  fabricante: string;
  fotos: IFoto;
  totallan: number;
  totalos: number;
}

export interface IDespesasCusto {
  dataemissao: Date;
  numerodoc: string;
  descricao: string;
  historico: string;
  parceiro: string;
  valor: number;
}

interface IItens {
  qtdsaida: number;
  descricao: string;
  referencia: string;
  un: string;
  preco: number;
  total: number;
}

export interface Ios {
  dataabertura: Date;
  datafechamento: Date;
  numero: string;
  mecanico: string;
  servicosrealizados: string;
  total: number;
  itens: IItens[];
}

export interface ICustoPatrimonio {
  despesa: IDespesasCusto[];
  os: Ios[];
  patrimonio: ICustoPatrimonios,
}

interface IReceitas {
  cultivo: string;
  planoconta: string;
  valor: number;
}

interface IPagas {
  cultivo: string;
  planoconta: string;
  valor: number;
}

interface IEstoque {
  cultivo: string;
  operacao: string;
  valor: number;
}

interface IOrdemservico {
  numero: string;
  descricao: string;
  valor: number;
}

export interface IDREfazenda {
  fazenda: string;
  receitas: IReceitas[];
  pagas: IPagas[];
  estoque: IEstoque[];
  os: IOrdemservico[];
}


interface IRecebimento {
  conta: string;
  recebimento: number;
}

interface IPagamento {
  conta: string;
  pagamento: number;
}

interface IFazendas {
  descricao: string;
  recebimento: number;
  pagamento: number;
  saldo: number;
}

export interface IDREGeral {
  recebimento: IRecebimento[];
  pagamentos: IPagamento[];
  fazendas: IFazendas[];
}

export interface IConta {
  idconta: number;
  nomebanco: string;
  agencia: string;
  numeroconta: string;
  saldo: number;
  saldo_total: number;
}

export interface IAplicacao {
  idconta: number;
  nomebanco: string;
  agencia: string;
  numeroconta: string;
  saldo: number;
  saldo_total: number;
}

export interface IDisponivel {
  conta: IConta[],
  aplicacao: IAplicacao[],
}

interface ErrorResponse {
  error: {
    default: string;
  };
}

const CustoPatrimonio = async (patrimonio: string, datainicial: string, datafinal: string): Promise<ICustoPatrimonio | Error> => {
  try {

    const urlRelativa = `/rcustopatrimonio?patrimonio=${patrimonio}&datainicial=${datainicial}&datafinal=${datafinal}`;

    const { data } = await ApiFinanceira.get(urlRelativa);
    if (data) {
      return data;
    }
    return new Error('Erro ao consultar o registro.');
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        const errorMessage = axiosError.response.data.error?.default || 'Erro desconhecido';
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    }
  }
};

const DREporFazenda = async (datainicial: string, datafinal: string): Promise<IDREfazenda[] | Error> => {
  try {

    const urlRelativa = `/dreporfazenda?datainicial=${datainicial}&datafinal=${datafinal}`;

    const { data } = await ApiFinanceira.get(urlRelativa);
    if (data) {
      return data;
    }
    return new Error('Erro ao consultar o registro.');
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        const errorMessage = axiosError.response.data.error?.default || 'Erro desconhecido';
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    }
  }
};

const DREGeral = async (datainicial: string, datafinal: string): Promise<IDREGeral | Error> => {
  try {

    const urlRelativa = `/dregeral?datainicial=${datainicial}&datafinal=${datafinal}`;

    const { data } = await ApiFinanceira.get(urlRelativa);
    if (data) {
      return data;
    }
    return new Error('Erro ao consultar o registro.');
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        const errorMessage = axiosError.response.data.error?.default || 'Erro desconhecido';
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    }
  }
};

const Disponivel = async (): Promise<IDisponivel | Error> => {
  try {
    const urlRelativa = '/disponivel';
    const { data } = await ApiFinanceira.get(urlRelativa);
    if (data) {
      return data;
    }
    return new Error('Erro ao consultar o registro.');
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        const errorMessage = axiosError.response.data.error?.default || 'Erro desconhecido';
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    }
  }
};

export const RelatorioFinanceiroService = {
  CustoPatrimonio,
  DREporFazenda,
  DREGeral,
  Disponivel,
};